import React, { useEffect, useRef, useState } from "react";
import "./CategoryProductPage.scss";
import ProductListCategory from "../../components/ProductListCategory/ProductListCategory";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAllProductsByCategory,
  fetchAsyncProductsOfCategory,
  getCategoryProductsStatus,
  getAllCategories,
} from "../../store/categorySlice";
import Loader from "../../components/Loader/Loader";
import { STATUS } from "../../utils/status";
import { Link } from "react-router-dom";
import { fetchAsyncCategories } from "../../store/categorySlice";

const CategoryProductPage = () => {
  const dispatch = useDispatch();
  const { category } = useParams(); // Assurez-vous que cela correspond à votre configuration de route
  const categoryProducts = useSelector(getAllProductsByCategory);
  const categoryProductsStatus = useSelector(getCategoryProductsStatus);
  const categories = useSelector(getAllCategories); // Récupérer toutes les catégories
  const carouselRef = useRef(null);
  const productsPerPage = 10; // Nombre de produits par page
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(fetchAsyncProductsOfCategory(category));
    dispatch(fetchAsyncCategories());
  }, [dispatch, category]);

  // Assurez-vous que category est converti en entier
  const categoryId = parseInt(category, 10);
  const categorie = categories.find((c) => c.id === categoryId); // Corrigez ici pour utiliser la bonne propriété

  const autoScroll = () => {
    if (carouselRef.current) {
      const { scrollWidth, scrollLeft, clientWidth } = carouselRef.current;

      if (scrollLeft < scrollWidth - clientWidth) {
        carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
      } else {
        carouselRef.current.scrollTo({ left: 0, behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const intervalId = setInterval(autoScroll, 4000);
    return () => clearInterval(intervalId);
  }, []);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  // Logique de pagination
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = categoryProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  // Changer de page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculer le nombre de pages
  const totalPages = Math.ceil(categoryProducts.length / productsPerPage);

  return (
    <div className="cat-products py-5 bg-whitesmoke">
      <div className="container">
        {/* Section du carrousel */}
        <div className="categories-itemsss mb-4">
          {" "}
          {/* Ajout d'une marge en bas pour séparer le carrousel */}
          <div className="carousel-container">
            <button className="carousel-btn left" onClick={scrollLeft}>
              &lt;
            </button>
            <button className="carousel-btn right" onClick={scrollRight}>
              &gt;
            </button>

            <div className="categories-carousel" ref={carouselRef}>
              {categories.map((category) => {
                const displayCategory = category?.name?.replace("-", " ");
                return (
                  <Link
                    to={`/category/${category.id}`}
                    key={category.id}
                    className="category-card"
                  >
                    <div className="category-card-content">
                      <p className="category-name text-capitalize">
                        {displayCategory}
                      </p>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>

        <div className="cat-products-content">
          <div className="title-md">
            <h3>
              See our products from Category{" "}
              <span className="text-capitalize">
                {categorie ? `: ${categorie.name}` : " - Unknown Category"}
              </span>
            </h3>
          </div>

          {categoryProductsStatus === STATUS.LOADING ? (
            <Loader />
          ) : categoryProductsStatus === STATUS.FAILED ? (
            <p className="no-products-message">
              No products found for the category{" "}
              {categorie ? `${categorie.name}` : "Unknown Category"}.
            </p> // Afficher un message d'erreur
          ) : (
            <ProductListCategory products={currentProducts} />
          )}

          <div className="paginationsss">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryProductPage;
